import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addDependency: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.add-dependency',
		defaultMessage: 'Add dependency',
		description: 'Label for the menu item which sets the search filter with the current issue',
	},
	lessThanOneDayLeadTimeShortFormat: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.less-than-one-day-lead-time-short-format',
		defaultMessage: '+ < 1d',
		description: 'Text for the label when the lead time is less than a day in a short date format',
	},
	multipleLinks: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.multiple-links',
		defaultMessage: 'Multiple links',
		description:
			'Label which is shown on an issue link when there are multiple links rolled up as a single link',
	},
	rollupLinkCountLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.rollup-link-count-label',
		defaultMessage: '{count} links',
		description: 'Text for the rollup label with the link',
	},
});
